(function () {
  function getSelectedValue(wrapper) {
    const checkedInput = wrapper.querySelector(
      "[data-single-option-selector]:checked",
    );

    if (checkedInput) {
      return checkedInput.value;
    }

    const popoutInput = wrapper.querySelector("[data-popout-input]");
    return popoutInput ? popoutInput.value : "";
  }

  function updateSelectedLabel(wrapper, value) {
    const label = wrapper.querySelector("[data-selected-option-value]");

    if (!label) {
      return;
    }

    const selectedValue = value || getSelectedValue(wrapper);

    if (selectedValue) {
      label.textContent = selectedValue;
    }
  }

  function updateAllSelectedLabels(root) {
    root
      .querySelectorAll("[data-selector-wrapper]")
      .forEach((wrapper) => updateSelectedLabel(wrapper));
  }

  document.addEventListener("change", (event) => {
    const input = event.target.closest("[data-single-option-selector]");

    if (!input) {
      return;
    }

    const wrapper = input.closest("[data-selector-wrapper]");

    if (wrapper) {
      updateSelectedLabel(wrapper, input.value);
    }
  });

  document.addEventListener("click", (event) => {
    const option = event.target.closest("[data-popout-option]");

    if (!option) {
      return;
    }

    const wrapper = option.closest("[data-selector-wrapper]");
    const value = option.dataset.value || option.textContent.trim();

    if (wrapper) {
      updateSelectedLabel(wrapper, value);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    updateAllSelectedLabels(document);
  });

  document.addEventListener("theme:product-info:loaded", (event) => {
    updateAllSelectedLabels(event.target);
  });
})();
